import type { FC, ReactNode } from "react";
import { useAudioPlayerTrigger } from "../audioPlayer/useAudioPlayerTrigger.js";
import { TranscriptMessage } from "./transcriptMessage.js";
import type { TranscriptSpeakerAvatarProps } from "./transcriptSpeakerAvatar.js";

export type PlayableTranscriptMessageProps = TranscriptSpeakerAvatarProps & {
  /** The audio player source this message belongs to. */
  sourceKey: string;
  /** The start time of this message, in seconds. */
  time: number;
  /** The start time of the next message, in seconds. */
  nextTime: number | undefined;
  children: ReactNode;
};

/** A transcript message wired to the audio player. */
export const PlayableTranscriptMessage: FC<PlayableTranscriptMessageProps> = (
  props,
) => {
  const { sourceKey, time, nextTime, children, ...speakerProps } = props;
  const { isCurrent, isPlaying, play, pause } = useAudioPlayerTrigger({
    sourceKey,
    time,
    nextTime,
  });

  return (
    <TranscriptMessage
      {...speakerProps}
      playback={{ time, isCurrent, isPlaying, onPlay: play, onPause: pause }}
    >
      {children}
    </TranscriptMessage>
  );
};
